import { Box } from "@mui/material";
import PageNotFoundError from "../../../asset/images/PageNotFoundError";
import PTButton from "./PTButton";

function PTNotFoundErrorPage(props) {
  const { onRetour } = props;
  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <PageNotFoundError />
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <PTButton
          title="retour"
          variant="outlined"
          onClick={() => {
            if (onRetour) onRetour();
          }}
        />
      </Box>
    </Box>
  );
}

export default PTNotFoundErrorPage;
